import { extendTheme } from '@mui/joy/styles';
import { BRAND } from './brand';

const theme = extendTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536
    }
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: '#eceef6',
          100: '#d8dbeb',
          200: '#b5b9d4',
          300: '#9297bd',
          400: '#5f6491',
          500: BRAND.colors.navy,
          600: BRAND.colors.navyDark,
          700: '#100f2e',
          800: '#0b0a22',
          900: '#060617'
        },
        neutral: {
          50: BRAND.colors.background,
          100: BRAND.colors.border,
          200: '#d5d8e4',
          300: '#b8bccf',
          400: '#8b90a8',
          500: BRAND.colors.textMuted,
          600: '#454560',
          700: BRAND.colors.text,
          800: '#12121f',
          900: '#080810'
        },
        background: {
          body: BRAND.colors.background,
          surface: BRAND.colors.surface,
          level1: BRAND.colors.background,
          level2: BRAND.colors.border
        },
        text: {
          primary: BRAND.colors.text,
          secondary: BRAND.colors.textMuted
        },
        danger: {
          50: '#ffebee',
          100: '#ffcdd2',
          200: '#ef9a9a',
          300: '#e57373',
          400: '#ef5350',
          500: '#e53935',
          600: '#d32f2f',
          700: '#c62828',
          800: '#b71c1c',
          900: '#8e0000'
        },
        warning: {
          50: '#fff8e1',
          100: '#ffecb3',
          200: '#ffe082',
          300: '#ffd54f',
          400: '#ffca28',
          500: '#ffc107',
          600: '#ffb300',
          700: '#ffa000',
          800: '#ff8f00',
          900: '#ff6f00'
        },
        success: {
          50: '#e8f5f0',
          100: '#cce8dc',
          200: '#9fd4bd',
          300: '#6fbf9c',
          400: '#45a67d',
          500: '#2d8a63',
          600: '#237052',
          700: '#1a5640',
          800: '#123c2d',
          900: '#0a221a'
        }
      }
    }
  },
  components: {
    JoyAlert: {
      styleOverrides: {
        root: ({ ownerState }) => {
          if (ownerState.color === 'danger' && ownerState.variant === 'soft') {
            return {
              backgroundColor: 'var(--joy-palette-danger-50)',
              color: '#d32f2f',
              border: '1px solid var(--joy-palette-danger-200)'
            };
          }
          if (ownerState.color === 'warning' && ownerState.variant === 'soft') {
            return {
              backgroundColor: 'var(--joy-palette-warning-50)',
              color: '#d32f2f',
              border: '1px solid var(--joy-palette-warning-200)'
            };
          }
          if (ownerState.color === 'success' && ownerState.variant === 'soft') {
            return {
              backgroundColor: 'var(--joy-palette-success-50)',
              color: 'var(--joy-palette-success-700)',
              border: '1px solid var(--joy-palette-success-200)'
            };
          }
          return {};
        }
      }
    }
  },
  fontFamily: {
    body: BRAND.fonts.body,
    display: BRAND.fonts.body
  },
  typography: {
    h1: { fontWeight: 600 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 }
  }
});

export default theme;
